import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { AccountDetailsConfig, controlData, VendorRemarksData } from "./AccountDetails.config";
import { useModalContext } from "../../Reactportal/ModalContext";
import { useLazyQuery, useMutation } from "@apollo/client";
import { EDIT_EMT_ACCOUNT, GetAccountDataByID } from "../../../../Utils/AllPagesQuriesAndMutations";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { useEventListener } from "usehooks-ts";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import Reactportal from "../../Reactportal/Reactportal";
import PortalFooter from "../../Reactportal/PortalFooter";
import Button from "../../Button/Button";
import { AddUser } from "../AddEmtAccount/AddUser";
import UserPreference from "../AddVendorAccount/UserPreferenceAndVehicleCategory/UserPreference";
import VehicleCategorySelection from "../AddVendorAccount/UserPreferenceAndVehicleCategory/VehicleCategorySelection";
import VendorRemarks from "../AddVendorAccount/AddVendorAccountSection/Remarks";
import ViewVendorFiles from "../AddVendorAccount/ViewFiles";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import AddEmtAccountSection from "../AddEmtAccount/AddEmtAccountSection/AddEmtAccountSection";

const AccountDetails = ({ TypeOfPortal, submitType, show, ParentPortalCloseFunction }) => {
  const Form_Key = "Account_Details";
  const formRef = useRef({});
  const { pushModal, popModal, getTopModal } = useModalContext();
  const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const [field, setFields] = useState(AccountDetailsConfig);
  const [toggle, setToggle] = useState(show);
  const fieldDataRedux = useSelector((store) => store.UniqueTableReducer);
  const fieldData = fieldDataRedux?.[Form_Key]?.Selected_Row;
  const [allFieldsData, setAllFieldsData] = useState();
  const dispatch = useDispatch();
  const [openAddUser, setOpenAddUser] = useState(false);
  const [showUserPreference, setShowUserPreference] = useState(false);
  const [showVehicleCategory, setShowCategory] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [FormData, setFormdata] = useState({});
  const [Remark, setRemark] = useState({
    Verified_Remark: "",
  });
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const [selectedRows, setSelectedRows] = useState([]);
  const [preferedFromCityLane, setPreferedFromCityLane] = useState([]);
  const [preferedToCityLane, setPreferedToCityLane] = useState([]);
  const [preferedVehicle, setPreferedVehicle] = useState([]);
  const [isFirstLoad, setFirstLoad] = useState(false);
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [RemarkFields, SetRemarkFields] = useState(VendorRemarksData["Is_Verified"]);
  const [ShowInfoModal, setShowInfoModal] = useState(false);
  const [loadingState, setLoadingState] = useState(false);

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  //Q & M
  const [getAccountDetailsById, { loading: getAccountDetailsLoading }] = useLazyQuery(GetAccountDataByID, {
    fetchPolicy: "network-only",
  });

  const [EditingData, { loading: editEmtAccountLoading }] = useMutation(EDIT_EMT_ACCOUNT(), {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const AccountDetailsLoadingState = getAccountDetailsLoading || editEmtAccountLoading;

  useEffect(() => {
    if (toggle) {
      pushModal(Form_Key);
    }
  }, [toggle, Form_Key, pushModal]);

  useEffect(() => {
    getAccountDetailsById({
      variables: {
        id: userData?.userDetails[0]?.Account_ID,
      },
    }).then(({ data }) => {
      let AccountDetailsData = { ...data?.Account };
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_Key,
          data: {
            Account_Group: { _id: AccountDetailsData?.Account_Groups?._id },
            Account_Manager: AccountDetailsData.Account_ManagerData,
          },
        },
      });
      if (AccountDetailsData && AccountDetailsData.Account_Groups) {
        AccountDetailsData.Account_Group = AccountDetailsData.Account_Groups.Account_Group;
      }
      if (AccountDetailsData && AccountDetailsData.Account_ManagerData) {
        AccountDetailsData.Account_Manager = AccountDetailsData.Account_ManagerData.Full_Name;
      }
      setAllFieldsData(AccountDetailsData);
      console.log(AccountDetailsData, "AccountDetailsData");
      updateValueForm(formRef, AccountDetailsData);
    });
  }, [fieldData, getAccountDetailsById]);

  useEffect(() => {
    if (allFieldsData) {
      updateValueForm(formRef, allFieldsData);
      if (allFieldsData?.VehicleTypeData) {
        setPreferedFromCityLane(allFieldsData?.LaneData?.From_Location);
        setPreferedToCityLane(allFieldsData?.LaneData?.To_Location);
        setPreferedVehicle(allFieldsData?.VehicleTypeData[0]?.Vehicle_Category_Management);
      }
    }
  }, [allFieldsData]);

  useEffect(() => {
    if (isFirstLoad) {
      setShowRemarkModal(FormData?.Not_Intrested);
      SetRemarkFields(VendorRemarksData["Not_Intrested"]);
    }
  }, [FormData?.Not_Intrested]);

  useEffect(() => {
    if (isFirstLoad) {
      setShowRemarkModal(FormData?.Is_Verified);
      SetRemarkFields(VendorRemarksData["Is_Verified"]);
    }
  }, [FormData?.Is_Verified]);

  formRef.current.OpenReviewModal = (fieldName) => {
    setShowInfoModal(true);
    SetRemarkFields(VendorRemarksData[fieldName.name] || fieldName);
  };

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  useEffect(() => {
    setSelectedRows(fieldDataRedux?.[Form_Key]?.Selected_Rows);
  }, [fieldDataRedux]);

  useEffect(() => {
    setLoadingState(loadingState);
  }, [loadingState]);

  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let formData = { ...FormData, ...Remark };

  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);

  const mutationFunctions = {
    EditingData,
  };

  const submit = async (closeAction) => {
    formData.Account_Manager = FormDataFromRedux?.MasterData[Form_Key]?.Account_Manager?._id;
    formData.Account_Group = FormDataFromRedux?.MasterData[Form_Key]?.Account_Group?._id;
    formData.Is_Verified = formData.Is_Verified || false;
    formData.Is_Document_Verified = formData.Is_Document_Verified || false;
    formData.Is_Lock = formData.Is_Lock || false;
    formData.Is_Mobile_Number_Verified = formData.Is_Mobile_Number_Verified || false;
    formData.Is_Email_Verified = formData.Is_Email_Verified || false;
    formData.Is_Aadhar_Verified = formData.Is_Aadhar_Verified || false;
    formData.Is_Pan_Verified = formData.Is_Pan_Verified || false;
    formData.Is_Gst_Verified = formData.Is_Gst_Verified || false;
    formData.Is_Bank_Verified = formData.Is_Bank_Verified || false;
    formData.KYC_Complete = formData.KYC_Complete || false;
    formData.CreateCSUser = formData.CreateCSUser || false;
    if (operationType !== "Delete") {
      delete formData.City;
      delete formData.State;
      if (formData.Aadhar_Number && typeof formData.Aadhar_Number !== "string") {
        formData.Aadhar_Number = formData.Aadhar_Number.toString();
      }
      if (formData.Aadhar_Number) {
        formData.Aadhar_Number = formData.Aadhar_Number.replace(/[^0-9]/g, "");
      }
    }
    const mutationFunction = getMutationFunction(operationType, mutationFunctions);

    const executeOperationFunction = () => {
      console.log(variables);
      return executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        EditRefresh: true,
        PageName: Form_Key,
        OnSuccess: () => {
          handleFormReset(formRef);
        },
      });
    };
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      Form_Key,
      operationType,
      closeAction,
      closeFormFunction: CloseFormFunction,
      resetFormDataFunction: handleFormReset(formRef),
      onSuccess: () => {},
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const handleKeyDown = (event) => {
    if (getTopModal() === Form_Key) {
      if (event.key === "Escape") {
        CloseFormFunction();
      }
    }
  };

  useEventListener("keydown", handleKeyDown);

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  const CloseFormFunction = useCallback(() => {
    popModal(Form_Key);
    setToggle(false);
    setAllFieldsData({});
    ClearSpecificForm(dispatch, Form_Key);
    ParentPortalCloseFunction();
  }, [Form_Key, dispatch]);

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  const HandleRemarkChange = (e) => {
    setRemark((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };

  const footerContent = (
    <PortalFooter
      renderContent={() => (
        <>
          {
            <>
              {TypeOfPortal !== "Add" && (
                <>
                  <Button action={() => setOpenAddUser(true)} name="modalbutton" text="Add User" />
                  {allFieldsData?.Profile_Type === "Transporter_Broker" && (
                    <>
                      <Button action={() => setShowUserPreference(true)} name="modalbutton" text="Preferred Lane" />
                      <Button action={() => setShowCategory(true)} name="modalbutton" text="Preferred Vehicle Type" />
                    </>
                  )}
                </>
              )}
            </>
          }
        </>
      )}
      disabled={false}
      submitform={() => Validate_handleSubmit(submit)}
      submitType={submitType}
      SaveAndClose={
        TypeOfPortal === "Add"
          ? () => {
              Validate_handleSubmit(SaveAndCloseForAdd);
            }
          : () => {
              Validate_handleSubmit(submit);
            }
      }
      handleformclose={() => {
        CloseFormFunction();
        setToggle(!toggle);
      }}
      loadingState={AccountDetailsLoadingState}
    />
  );

  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={CloseFormFunction}
          TypeOfPortal={TypeOfPortal}
          TypeOfId={`${allFieldsData?.Unique_Id}`}
          id={allFieldsData?.Unique_Id}
          Form_Key={Form_Key}
          idTitle={"Account ID"}
        >
          <div className="PartyAccountSection">
            {AccountDetailsLoadingState && <div className="loader-line-div" />}
            <div className="formContainer">
              {field &&
                field.map((e) => {
                  return (
                    <>
                      <AddEmtAccountSection
                        inputfields={e.fields}
                        Type={e.name}
                        Data={e}
                        TypeOfPortal={TypeOfPortal}
                        controlData={controlData}
                        handleErrorsChange={handleErrorsChange}
                        HanldeChangeonForm={HanldeChangeonForm}
                        formkey={Form_Key}
                        formRef={formRef}
                        setFirstLoad={setFirstLoad}
                        isFirstLoad={isFirstLoad}
                      />
                    </>
                  );
                })}
            </div>
          </div>
        </Reactportal>
      </div>
      {openAddUser && (
        <AddUser
          show={openAddUser}
          TypeOfPortal={TypeOfPortal}
          fielddata={allFieldsData}
          submitType={submitType}
          AccountId={userData?.userDetails[0]?.Account_ID}
          setOpenAddUser={setOpenAddUser}
        />
      )}
      {showUserPreference && (
        <UserPreference
          show={true}
          TypeOfPortal={TypeOfPortal}
          vehicleIds={preferedVehicle}
          formCities={preferedFromCityLane}
          toCities={preferedToCityLane}
          setPreferedVehicle={(val) => setPreferedVehicle(val)}
          setShowModal={() => setShowUserPreference(false)}
          setPreferedFromCityLane={(val) => setPreferedFromCityLane(val)}
          setPreferedToCityLane={(val) => setPreferedToCityLane(val)}
          allFieldsData={allFieldsData}
        />
      )}
      {showVehicleCategory && (
        <VehicleCategorySelection
          show={true}
          setShowModal={() => setShowCategory(false)}
          vehicleIds={preferedVehicle}
          setPreferedVehicle={(val) => setPreferedVehicle(val)}
          allFieldsData={allFieldsData}
        />
      )}
      {showRemarkModal && (
        <VendorRemarks
          show={showRemarkModal}
          onhandleFormikChange={HandleRemarkChange}
          field={RemarkFields}
          values={Remark}
          setShowModal={() => setShowRemarkModal(false)}
        />
      )}
      {ShowInfoModal && (
        <ViewVendorFiles
          Values={formRef?.current?.Controls?.values}
          show={true}
          TypeOfPortal={TypeOfPortal}
          setShowModal={() => setShowInfoModal(false)}
          accountId={userData?.userDetails[0]?.Account_ID}
          Remark={Remark}
          Type={
            RemarkFields.name === "Is_Pan_Verified"
              ? "PAN"
              : RemarkFields.name === "Is_Gst_Verified"
              ? "GST"
              : RemarkFields.name === "Is_Aadhar_Verified"
              ? "Aadhaar"
              : RemarkFields.name === "Verified_Remark"
              ? "verified"
              : RemarkFields.name === "Not_Intrested_Remark"
              ? "Not_Intrested"
              : "Bank"
          }
        />
      )}
    </>
  );
};

export default AccountDetails;
